import React from "react";
import "./Header.css";
import { Flex } from "@aws-amplify/ui-react";

import Logo from "../Logo";
import HeaderNav from "./HeaderNav";
import { useMyContext } from "../../context/DataContext";


const Header = () => {
  const { } = useMyContext();

  const queryString = window.location.search;

  return (
    <div className="header">
      <Flex
        direction="row"
        alignItems="center"
        wrap="nowrap"
        gap="1rem"
        justifyContent="space-between"
      >
        <div className="header-left">
          <div className="header-logo">
            <a href={`/${queryString ? queryString : ""}`}>
              <Logo />
            </a>
          </div>
        </div>

        <div className="header-right">
        
          <HeaderNav />
        </div>
      </Flex>
    </div>
  );
};

export default Header;
